import { useModalDisclosure } from '@hooks/session';
import { useDocumentsViewContext } from '@views/ProofDocuments/hooks/useDocumentsContext';

export const useController = ({ onClose }) => {
  const {
    isOpen: isCancelOpen,
    onOpen: onOpenCancel,
    onClose: onCancelClose,
  } = useModalDisclosure();

  const { activeRequisition, isVIP } = useDocumentsViewContext();
  const { status: requisitionStatus } = activeRequisition || {};

  const onCancelOpen = () => {
    onOpenCancel();
    onClose();
  };

  return {
    isVIP,
    isCancelOpen,
    onCancelOpen,
    onCancelClose,
    requisitionStatus,
  };
};
